import React from "react";
import {
  createBrowserRouter,
  RouteObject,
  RouterProvider,
} from "react-router-dom";

import { IgErrorBoundary } from "@src/components/Utils/IgErrorBoundary";
import { AdminNoPaddingPageProvider } from "@src/providers/AdminNoPaddingPageProvider";
import { AdminPageProvider } from "@src/providers/AdminPageProvider";
import { FullPageProvider } from "@src/providers/FullPageProvider";
import { LoggedInProvider } from "@src/providers/LoggedInProvider";
import { StandardNoPaddingPageProvider } from "@src/providers/StandardNoPaddingPageProvider";
import { StandardPageProvider } from "@src/providers/StandardPageProvider";
import { AdminPageRoutes } from "@src/routes/loggedIn/adminPageRoutes";
import { AdminNoPaddingRoutes } from "@src/routes/loggedIn/adminPageRoutes/adminNoPaddingRoutes";
import { StandardNoPaddingRoutes } from "@src/routes/loggedIn/standardNoPaddingRoutes";
import { PublicPageRoutes } from "@src/routes/public/public-page-routes";

import { FullPageRoutes } from "./fullPageRoutes";
import { StandardPageRoutes } from "./standardPageRoutes";

const routes: RouteObject[] = [
  {
    errorElement: <IgErrorBoundary />,
    element: <LoggedInProvider />,
    children: [
      {
        element: <AdminPageProvider />,
        children: AdminPageRoutes,
      },
      {
        element: <AdminNoPaddingPageProvider />,
        children: AdminNoPaddingRoutes,
      },
      {
        element: <StandardPageProvider />,
        children: StandardPageRoutes,
      },
      {
        element: <FullPageProvider />,
        children: FullPageRoutes,
      },
      {
        element: <StandardNoPaddingPageProvider />,
        children: StandardNoPaddingRoutes,
      },
      ...PublicPageRoutes,
    ],
  },
];
const router = createBrowserRouter(routes);

export const SubscribedRoutes = () => {
  return <RouterProvider router={router} />;
};
